import React, {useEffect} from 'react';


import PropTypes from "prop-types";



function DrdTable(props) {

    return (
        <>
            <div
                className="card flex-column justify-content-around ml-5"
                style={{
                    textAlign: "center",
                    boxShadow:
                        "inset 0.1em 0.1em 0.1em 0 rgb(221, 230, 237,0.18), inset -0.1em -0.1em 0.1em 0 rgba(0,0,0,0.6)",
                    backgroundColor: "rgb(82, 109, 130, 0.92)", // dark silver
                    color: "#ffffff", // white text
                    borderRadius: "10px",
                    padding: "2px",
                }}
            >
                {props.dues && props.dues.length > 0 ? (
                    props.dues.map((result, index) => (
                        <div key={index} className="p-0 md:text-[1vw]" style={{ fontSize: "1vw" }}>
                            {result}
                        </div>
                    ))
                ) : (
                    <div>No dues available</div>
                )}
            </div>
        </>
    );
}
DrdTable.propTypes = {
dues: PropTypes.array.isRequired,

}

export default DrdTable;

